import {FuseLoadable} from '@fuse';

export const RpHealthstatusConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayiaas/RpHealthstatus',
            component: FuseLoadable({
                loader: () => import('../../dashboards/analytics/AnalyticsDashboardApp')
              
            })
        },
      
       
      

    ]
};

